import React, {useState, useEffect} from 'react';

// import PropTypes from 'prop-types';
import { Autocomplete } from '@mui/material';
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogContentText,
  DialogActions,
  // Divider,
  Button,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  // FormControl,
  Grid,
  FormGroup,
  FormControl,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

// import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

import {  KeyboardDatePicker } from '@material-ui/pickers';
import { DateTimePicker } from '@material-ui/pickers';
import {
  emptyCpapEventState, CpapEventProps, Apparatus, SubjectProps, emptySubjectState,
} from '../common/entityUtilities';



import { useCpapEventListState, useCpapEventListDispatch, CpapEventListTypes } from '../context/CpapEventListContext';

import { useUserDispatch, useUserState } from '../context/UserContext';
import { VentilationMode } from '../common/entityUtilities';

import {
  setCpapEventInfo,
  setSubjectInfo
} from '../common/apiSetUtilities';


import { 
  SubjectSchemaProps
} from '../common/mongoSchemas';
import { useSubjectListState } from '../context/SubjectListContext';
import { getSubject } from '../common/apiGetUtilities';

type UIPropsForNewEventDialog = {
  _id: string|undefined;
  flow: number;
  deviceId: string;
  subjectId: string;
  cpapLevel: number;
  deviceStatus: boolean;
  oxygenPercent: number;
  oxygenSaturation: number;
  apneaBradyCardia: boolean;
  comments: string;
  apparatus: any; // prong, mask, ram cannula,
  position: string;
  chest_wiggle: string;
  updatedAt: Date;
};

const emptyEventUIState:UIPropsForNewEventDialog = {
  _id: undefined,
  flow: 0,
  deviceId: '',
  subjectId: '',
  cpapLevel: 0,
  deviceStatus: false,
  oxygenPercent: 0,
  oxygenSaturation: 0,
  apneaBradyCardia: false,
  comments: '',
  apparatus: undefined,
  position: 'supine',
  chest_wiggle: '',
  updatedAt: new Date()
};

export type EventInfoDialogProps = {
  isOpen:boolean,
  deviceId: string,
  dialogComplete:()=>void,
  currentSubjectForDevice: any,
  eventInformation:CpapEventProps|null

};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(2),
        width: 200,
      },
    },
  }),
);

export const CpapEventInfoDialog = (props:EventInfoDialogProps):JSX.Element=> {
  const classes = useStyles();
  // userInformation is UserProps
  const {isOpen, dialogComplete, eventInformation, deviceId, currentSubjectForDevice}  = props;
  
  const userState = useUserState();
  const eventListDispatch = useCpapEventListDispatch();
  const {allSubjects} = useSubjectListState();

  const [dialogValue, setDialogValue] = useState(emptyEventUIState);
  const [displayEventInformation, setDisplayEventInformation] = useState(true);
  const [selectedSubject, setSelectedSubject] = useState(emptySubjectState);
  // this can probably be replaced by the emmaUserId
  const [isNewEvent, setIsNewEvent] = useState(true);
  const [apparatus, setApparatus] = useState("");
  const [position, setPosition] = useState("");
  const [chest_wiggle, setChestWiggle] = useState('');
  

  const [errors, setErrors] = useState<any>({});

  const allApparatus = ['Prong', 'Mask', 'Canula'];
  const allPositions = ['Supine', 'Prone', 'LLD', 'RLD'];
  const allWiggles = ['Not recorded', 'Poor', 'Moderate', 'Good'];


  useEffect(()=>{
    
    if(eventInformation === null){
      console.log('Dialog reset');
      return;
    }
    if(eventInformation?.subjectId == ''){
      console.log('Logging new event with device:',deviceId);
      setDisplayEventInformation(true);
      setIsNewEvent(true);
      setSelectedSubject(currentSubjectForDevice);
      setDialogValue({...emptyEventUIState, deviceId: deviceId});
      setApparatus("");
      console.log('Dialog values:', {...emptyEventUIState, deviceId: deviceId});
      return;      
    }

    setDisplayEventInformation(false);
    setIsNewEvent(false);

    setApparatus(eventInformation?.apparatus);
    setPosition(eventInformation?.position);
    setChestWiggle(eventInformation?.chest_wiggle);

    console.log('eventInformation in [useEffect]:', eventInformation);
    let dialogValues:UIPropsForNewEventDialog =  {...emptyEventUIState, 
      _id: eventInformation._id,
      flow: eventInformation.flow,
      cpapLevel: eventInformation.cpapLevel,
      deviceId: eventInformation.deviceId,
      subjectId: eventInformation.subjectId,
      deviceStatus: eventInformation.deviceStatus,
      oxygenPercent: eventInformation.oxygenPercent,
      oxygenSaturation: eventInformation.oxygenSaturation,
      apneaBradyCardia: eventInformation.apneaBradyCardia,
      comments: eventInformation.comments,
      apparatus: eventInformation.apparatus,
      position: eventInformation.position,
      updatedAt: eventInformation.updatedAt,
      chest_wiggle: eventInformation.chest_wiggle
      
    };
    console.log('Setting dialogValues:', dialogValues);
    setDialogValue(dialogValues);
    

    if (eventInformation?.subjectId){
      // event has an associated subject
      const subject = allSubjects.filter(x=>x._id==eventInformation.subjectId);
      if (subject.length > 0){
        setSelectedSubject(subject[0]); //ideally only one item passes the above test
        console.log('Setting selected subject to:', subject[0]);
      }
    }
   
  },[eventInformation]);
  
  useEffect( ()=>{
    console.log('Apparatus:', apparatus);
  },[apparatus]);


  useEffect( ()=>{
    console.log('Position:', position);
    allPositions.map( (option) => {
      if (option.toLocaleLowerCase() == position.toLocaleLowerCase()){
        setPosition(option);
      }
    })
  },[position]);


  useEffect( ()=>{
    console.log('chest_wiggle:', chest_wiggle);
    allWiggles.map( (option) => {
      if (option.toLocaleLowerCase() == chest_wiggle.toLocaleLowerCase()){
        setChestWiggle(option);
      }
    })
  },[chest_wiggle]);

  const updateUIWithValues = (createNewEvent: boolean, eventId: string | undefined, 
    eventPropertiesMongoDb: Partial<CpapEventProps>) =>{

    let newPropsForEvent = eventPropertiesMongoDb;
    // hope and pray the createNewUser is accurate. The userProperties are only what got update
    // maybe it should include the id of what was update.
    if(createNewEvent){
      const newEvent = {...emptyEventUIState, ...newPropsForEvent };
      console.log('Dispatching new cpap event:', newEvent);
      eventListDispatch({type:CpapEventListTypes.ADD_EVENT, allCpapEvents:[newEvent]});
    }else{
      // updating a cpap event that exists
      console.log('Updating with', newPropsForEvent);
      
      eventListDispatch({type:CpapEventListTypes.UPDATE_EVENT, allCpapEvents:[newPropsForEvent]});
      
    }
  };
  


  const handleClose = () => {
    // new way of reseting dialog state when closing.
    setErrors({});
    setDialogValue(emptyEventUIState);
    console.log('Closing dialog');
    dialogComplete();
  };


  
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    console.log('[handleSubmit] dialogValue:', dialogValue);
    console.log('[handleSubmit] eventInformation:', eventInformation);



    // Copied from UserSettings component
    const mongoEventValuesToUpdate:Partial<CpapEventProps> = {
      flow: dialogValue.flow,
      deviceId: dialogValue.deviceId,
      subjectId: selectedSubject && selectedSubject._id,
      cpapLevel: dialogValue.cpapLevel,
      deviceStatus: dialogValue.deviceStatus,
      oxygenPercent: dialogValue.oxygenPercent,
      oxygenSaturation: dialogValue.oxygenSaturation,
      apneaBradyCardia: dialogValue.apneaBradyCardia,
      comments: dialogValue.comments,
      apparatus: dialogValue.apparatus,
      position: dialogValue.position,
      chest_wiggle: dialogValue.chest_wiggle,
      updatedAt: dialogValue.updatedAt
      
    };//

    
  

    // The user that is saving things
    const firebaseUser = userState.firebaseUser;
    // hmm wont this naturally be undefined?
    let eventToUpdateId = eventInformation?._id;
    if(isNewEvent) eventToUpdateId = undefined;

    setCpapEventInfo(firebaseUser, eventToUpdateId, mongoEventValuesToUpdate)
      .then(storedUserData=>{ // Stored data is CpapEventSchemaProps
        console.log('UpdateUI with values:', storedUserData);
        updateUIWithValues(isNewEvent, eventToUpdateId, storedUserData);
        
      }).finally( ()=>{
        handleClose();
      }
      );
    //handleClose();
  };

  //Ugh, this UI should to be split/updated for two components, one for user and the
  // other for parents
  return (

    <Dialog
      aria-labelledby="form-dialog-title"
      onClose={handleClose}
      open={isOpen}
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle id="form-dialog-title">          
          {eventInformation?'Update event':'Create event'}
        </DialogTitle>
        <DialogContent className={classes.root}>
          <div>
          <TextField
              autoFocus
              label="Time stamp"
              value={dialogValue?.updatedAt && 
                new Date(dialogValue?.updatedAt).toLocaleDateString('en-us') + ", " + 
                new Date(dialogValue?.updatedAt).toLocaleTimeString('en-us')}/>

          <DateTimePicker
              label="Change event time"
              margin="normal"
              onChange={(date: Date|null)=>{date && setDialogValue({...dialogValue, updatedAt:date})}}
              value={dialogValue?.updatedAt}
            />


           
            
            <TextField
            autoFocus                
            id="flow"
            label="Flow"
            margin="dense"
            onChange={(event) => setDialogValue({ ...dialogValue, flow: parseFloat(event.target.value) })}
            type="number"
            value={dialogValue.flow}
            />
            <TextField
            autoFocus                
            id="cpapLevel"
            label="Cpap Level"
            margin="dense"
            onChange={(event) => setDialogValue({ ...dialogValue, cpapLevel: parseFloat(event.target.value) })}
            type="number"
            value={dialogValue.cpapLevel}
            />
            <TextField
            autoFocus                
            id="oxygenPercent"
            label="Oxygen Percentage"
            margin="dense"
            onChange={(event) => setDialogValue({ ...dialogValue, oxygenPercent: parseFloat(event.target.value) })}
            type="number"
            value={dialogValue.oxygenPercent}
            />
            <TextField
            autoFocus                
            id="oxygenSaturation"
            label="Oxygen Saturation"
            margin="dense"
            onChange={(event) => setDialogValue({ ...dialogValue, oxygenSaturation: parseFloat(event.target.value) })}
            type="number"
            value={dialogValue.oxygenSaturation}
            />

          <Autocomplete
            freeSolo
            componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            id='notes-autocomplete'
            value={dialogValue.comments}
            options={['Suctioning', 'ETT Change', 'Surfactant']}
            disableClearable
            onChange={ (event,value) => {
              setDialogValue({...dialogValue, comments: value});
            }}
            renderInput={ (params) => (
              <TextField {...params}
              fullWidth
              label="Notes"
              onChange={(event)=> {
                setDialogValue({...dialogValue, comments: event.target.value});
              }}
              InputProps={ {
                ...params.InputProps,
                type:'search'
              }}/>
            )}      
          />


            <FormControl fullWidth>
              <InputLabel >Choose subject</InputLabel>
              <Select 
                  id="subject"
                  label="Subject"
                  disabled={true}
                  value={selectedSubject && selectedSubject.patientIdentifier}
                  // m={2}
                  onChange={ async (event:any) => {
                      setDialogValue({ ...dialogValue, subjectId: event.target.value});
                      console.log('Current subject:', selectedSubject);
                      console.log('Chosen:', event.target);
                      const subject = await getSubject(userState, event.target.value);
                      console.log('Setting subject to:', subject);
                      setSelectedSubject(subject && subject[0]);
                    }
                  }
                >
                  {allSubjects && allSubjects.map((option) => (
                    <MenuItem
                      key={option._id}
                      value={option.patientIdentifier}
                    >
                      {option.patientIdentifier}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

          <FormControl fullWidth>
            <InputLabel >Cpap Apparatus</InputLabel>
            <Select 
                id="apparatus"
                label="Cpap Apparatus"
                defaultValue=""
                value={apparatus && apparatus}
                // m={2}
                onChange={(event:any) => {
                  setDialogValue({ ...dialogValue, apparatus: event.target.value});
                  setApparatus(event.target.value);
                  console.log('Current mode:', apparatus);
                  console.log('Setting apparatus:', event.target.value);
                  }
                }
              >
                {allApparatus && allApparatus.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                    selected = {apparatus == option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
            <InputLabel >Infant Position</InputLabel>
            <Select 
                id="position"
                label="Infant Position"
                defaultValue=""
                value={position && position}
              
                // m={2}
                onChange={(event:any) => {
                  setDialogValue({ ...dialogValue, position: event.target.value});
                  setPosition(event.target.value);
                  console.log('Current position:', position);
                  console.log('Setting position:', event.target.value);
                  }
                }
              >
                {allPositions && allPositions.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                    selected = {position == option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>


            <FormControl fullWidth>
            <InputLabel >Chest Wiggle Factor</InputLabel>
            <Select 
                id="chest_wiggle"
                label="Chest Wiggle Factor"
                defaultValue=""
                value={chest_wiggle && chest_wiggle}
                // m={2}
                onChange={(event:any) => {
                  setDialogValue({ ...dialogValue, chest_wiggle: event.target.value});
                  setChestWiggle(event.target.value);
                  console.log('Current wiggle:', chest_wiggle);
                  console.log('Setting wiggle:', event.target.value);
                  }
                }
              >
                {allWiggles && allWiggles.map((option) => (
                  <MenuItem
                    key={option}
                    value={option}
                    selected = {chest_wiggle == option}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>         

        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={handleClose}
          >
              Cancel
          </Button>
          <Button
            color="primary"
            disabled={Object.keys(errors).length > 0 || !dialogValue.deviceId}
            type="submit"
          >
            {eventInformation? 'Update':'Create'}              
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
